import React, { Component } from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";

import Page from "../Page";
import heppy from "img/heppy.png";
import restartSVG from "img/restart.svg";

import Popup from "../popup/Popup4.js";

export default class Conclusion extends Component {
  constructor(props) {
    super(props);
    this.state = { showPopup: false };
  }

  showPopup = () => {
    this.setState({ showPopup: true });
  };

  handleSendClick = () => {
    const { email, sendPdfWithStoreMetrics, storeNumber } = this.props;

    if (!!email && !!storeNumber) {
      sendPdfWithStoreMetrics();
      this.showPopup();
    }
  };

  render() {
    const { showPopup } = this.state;
    const { resetData, email, onEmailChange } = this.props;
    ReactGA.pageview('/conclusion')

    return (
      <Page>
        <div className="conclusion-page">
          <div className="introduction-page__restart-block">
            <ul className="arrival-page__arms-list">
              <li className="full-word-s">Access</li>
              <li className="full-word">Replenish</li>
              <li className="full-word">Manage</li>
              <li className="full-word-s">Secure</li>
            </ul>
            <Link
              to={{ pathname: "/login", state: { prev: true } }}
              className="introduction-page__restart-btn"
              href="#"
              onClick={resetData}
            >
              <img
                className="introduction-page__restart-icon"
                src={restartSVG}
                alt=""
              />
              <span>Restart</span>
            </Link>
          </div>

          <div className="conclusion-page__main-section">
            <div className="conclusion-page__heppy-container">
              <img className="conclusion-page__heppy" src={heppy} alt="" />
            </div>

            <div className="conclusion-page__text-container">
              <div className="conclusion-page__text">
                <h1>Successful Sale!</h1>
                <p className="conclusion-page__text-content conclusion-page__text-content--black bold">
                  Our customer has successfully made their purchase and you have
                  learned more about how the pick ticket process affects your
                  store.
                </p>
                <p className="conclusion-page__text-content conclusion-page__text-content--black">
                  Understanding the ins and outs of the process in the aisle, at
                  the register, and in the cage is important to both your bottom
                  line and the customer experience.
                </p>
              </div>

              <div className="conclusion-page__text">
                <p className="conclusion-page__text-content conclusion-page__text-content--white">
                  To help your associates get their ARMS around the pick ticket
                  process, enter your email to receive an infographic with more
                  of your store’s pick ticket/cage metrics.
                </p>
                <input
                  autoComplete="off"
                  className="conclusion-page__email-input"
                  type="text"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={onEmailChange}
                />

                <div className="conclusion-page__buttons">
                  <Link
                    to={{
                      pathname: "/conclusion",
                      state: { prev: true }
                    }}
                    onClick={this.handleSendClick}
                    className="simple-btn"
                  >
                    <span>Send</span>
                  </Link>
                  <span className="simple-btn-space">or</span>
                  <Link
                    to={{
                      pathname: "/login",
                      state: { prev: true }
                    }}
                    className="simple-btn simple-btn--red"
                    onClick={resetData}
                  >
                    <span>Exit</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {showPopup && <Popup resetData={resetData} />}
        </div>
      </Page>
    );
  }
}
